module.exports = __webpack_public_path__ + "assets/img/poster.04b81096.png";